import $ from 'jquery';
import _forEach from 'lodash/forEach';
import _isNaN from 'lodash/isNaN';
import { SELECTORS } from '../constants/selectors';
import GameController from '../game/GameController';
import { GAME_ATTACK_TYPES, GAME_ATTACK_VALUES } from '../constants/gameAttackConstants';

/**
 * TODO: !!!THIS CLASS MAY BE BROKEN DUE TO THE REFACTORING OF THE ATTACKS!!!
 * /

/**
 * @property UI_SETTINGS_MODAL_TEMPLATE
 * @type {string}
 * @final
 */
const UI_ATTACKS_DOWNLOAD_MODAL_TEMPLATE = `
    <div class="option-dialog dialog notSelectable">
        <p class="dialog-title">ADS-B Attacks Download</p>
        <div class="dialog-body nice-scrollbar"></div>
    </div>`;

/**
 * @property UI_ATTACKS_DOWNLOAD_ATTACK_DATA
 * @type {string}
 * @final
 */
const UI_ATTACKS_DOWNLOAD_ATTACK_DATA = `
    <button type="button" class="dialog-body-download-button"
            id="${SELECTORS.IDS.DOWNLOAD_ATTACK_LOG}" value="Download attack data">
        Download attack data
    </button> 
`;

// /**
//  * @property UI_ATTACKS_DOWNLOAD_ATTACK_LOG
//  * @type {string}
//  * @final
//  */
// const UI_ATTACKS_DOWNLOAD_ATTACK_LOG = `
//     <button type="button" class="dialog-body-download-button" 
//             id="${SELECTORS.IDS.DOWNLOAD_LOGFILE}" value="Download logfile">
//         Download logfile
//     </button>
// `;

/**
 * @property UI_ATTACKS_DOWNLOAD_ATTACK_STOP
 * @type {string}
 * @final
 */
const UI_ATTACKS_DOWNLOAD_ATTACK_STOP = `
    <button type="button" class="dialog-body-download-button"
            id="${SELECTORS.IDS.DOWNLOAD_ATTACK_LOG_STOP}" value="Stop attack download">
        Stop attack download
    </button>
`;

/**
 * @property UI_ATTACKS_DOWNLOAD_ATTACK_TEXT
 * @type {string}
 * @final
 */
const UI_ATTACKS_DOWNLOAD_ATTACK_TEXT = `
    <p class="dialog-text">
        Here can you download the attack data. The collection period can be set below.
    </p>
`;

/**
 * @property UI_OPTION_CONTAINER_TEMPLATE
 * @type {string}
 * @final
 */
const UI_OPTION_CONTAINER_TEMPLATE = '<div class="dialog-text dialog-attack-download-form"></div>';

/**
 * @property UI_ATTACKS_DOWNLOAD_BUTTON_CONTAINER
 * @type {string}
 * @final
 */
const UI_ATTACKS_DOWNLOAD_BUTTON_CONTAINER = `
    <div class="dialog-body-button-container"></div>
`;

/**
 * @property UI_ATTACKS_DOWNLOAD_ATTACK_COUNTDOWN
 * @type {string}
 * @final
 */
const UI_ATTACKS_DOWNLOAD_ATTACK_COUNTDOWN = `
    <p class="dialog-text">
        The attack data will download after: <span id="${SELECTORS.IDS.DOWNLOAD_ATTACK_LOG_COUNTDOWN}"></span>
    </p>
`;

/**
 * @class AttacksDownloadController
 */
export default class AttacksDownloadController {
    constructor($element, scopeModel) {
        /**
         * Root DOM element
         *
         * @property $element
         * @type {jquery|HTML Element}
         * @default $element
         */
        this.$element = $element;

        /**
         * Dialog DOM element
         *
         * @property $dialog
         * @type {jquery|HTML Element}
         * @default null
         */
        this.$dialog = null;

        /**
         * Dialog's body DOM element
         *
         * @property $dialogBody
         * @type {jquery|HTML Element}
         * @default null
         */
        this.$dialogBody = null;

        /**
         * @property _scopeModel
         * @type {ScopeModel}
         * @default null
         * @private
         */
        this._scopeModel = scopeModel;

        /**
         * @property _downloadAttackDataInProgess
         * @type {boolean}
         * @default false
         * @private
         */
        this._downloadAttackDataInProgess = false;

        /**
         * @property _downloadAttackDataInterval
         * @type {number}
         * @default null
         * @private
         */
        this._downloadAttackDataInterval = null;

        /**
         * @property _downloadAttackDataCountdown
         * @type {number}
         * @default null
         * @private
         */
        this._downloadAttackDataCountdown = null;

        this._downloadAttackDataCollectionPeriod = 30; // seconds

        this._downloadAttack = this._downloadAttack.bind(this);
        this._downloadAttackStop = this._downloadAttackStop.bind(this);

        this.init();
    }

    /**
     * Initialize the AttacksDownloadController
     * 
     * @for AttacksDownloadController
     * @method init
     * @chainable
     */
    init() {
        this.$dialog = $(UI_ATTACKS_DOWNLOAD_MODAL_TEMPLATE);
        this.$dialogBody = this.$dialog.find(SELECTORS.DOM_SELECTORS.DIALOG_BODY);

        const $dataCollectionSelecter = this._buildOptionForMinutes(); // This is not needed for now, but might be useful in the future for machine learning //Zebastian

        this.$dialogBody.append(UI_ATTACKS_DOWNLOAD_ATTACK_TEXT);
        this.$dialogBody.append($dataCollectionSelecter); // This is not needed for now, but might be useful in the future for machine learning //Zebastian
        this.$dialogBody.append(UI_ATTACKS_DOWNLOAD_ATTACK_COUNTDOWN); // This is not needed for now, but might be useful in the future for machine learning //Zebastian

        const $buttons = this._buildDownloadButtons();
        this.$dialogBody.append($buttons);

        this.$element.append(this.$dialog);

        return this;
    }

    /**
     * Returns whether the attacks download dialog is open or not.
     *
     * @for AttacksDownloadController
     * @method isDialogOpen
     * @return {boolean}
     */
    isDialogOpen() {
        return this.$dialog.hasClass(SELECTORS.CLASSNAMES.OPEN);
    }

    /**
     * Toggles the visibility of the attacks download dialog.
     * 
     * @for AttacksDownloadController
     * @method toggleDialog
     */
    toggleDialog() {
        this.$dialog.toggleClass(SELECTORS.CLASSNAMES.OPEN);
    }

    /**
     * Downloads simulation log. !!!Disabled for now as it as we have the test log!!!
     * 
     * @for AttacksDownloadController
     * @method _downloadSimulationLog
     * @private
     */
    _downloadSimulationLog() {
        var startText = "Starting Settings: \n";
        for (let i = 0; i < GAME_ATTACK_VALUES.length; i++){
          var displayLab = "";
          var optionsA = GAME_ATTACK_VALUES[i].optionList
          for (let j = 0; j < optionsA.length; j++){
            if (optionsA[j].value === GAME_ATTACK_VALUES[i].defaultValue){
              displayLab = optionsA[j].displayLabel;
              break;
            }
          }
          startText += GAME_ATTACK_VALUES[i].description+": "+displayLab+"\n";
        }
        startText += "\n\n\n"
        console.log(startText);
        console.log(GameController.optionUpdate);
  
  
        var finalText = startText + GameController.optionUpdate + "\n\n\n" + GameController.log;
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(finalText));
        element.setAttribute('download', "log.txt");
  
        element.style.display = 'none';
        document.body.appendChild(element);
  
        element.click();
  
        document.body.removeChild(element);
    }

    /**
     * Downloads a .csv file with information about flights that currently are affected by some attack.
     * The type of data is similar to that of a real ADS-B message.
     * Downloads continously for a set number of minutes.
     * 
     * @for AttacksDownloadController
     * @method _downloadAttack
     * @private
     */
    _downloadAttack() {
        if (this._downloadAttackDataInProgess) {
            return;
        }
    
        this._downloadAttackDataInProgess = true;

        const radarTargetModels = this._scopeModel.radarTargetCollection.items;
        let seconds = this._downloadAttackDataCollectionPeriod * 60;  /* Set the time for the attack data to be downloaded */
        let finalText = "icao, callsign, time_position, last_contact, long, lat, baro_alt, on_ground, velocity, true_track, vertical_rate, geo_alt, squawk, label, attack_type";
        finalText += '\n';

        let start = performance.now();
        let sleep = 500; // interval between "broadcasts" (ms)

        this._downloadAttackDisplayCountdown(seconds);

        this._downloadAttackDataInterval = setInterval(() => {
            for (let i = 0; i < radarTargetModels.length; i++) {
                const { aircraftModel } = radarTargetModels[i];

                if (aircraftModel.attackType != 0) { // If the current aircraft isn't of attack-type "regular" (=> affected)
                    // Formating the fields
                    let last_contact = (aircraftModel.lastContact == "") ?
                        "-" : aircraftModel.lastContact;

                    let time_position = new Date(Date.now()).toLocaleString();

                    aircraftModel.lastContact = time_position;

                    let callsign = aircraftModel.callsign;

                    let long = String(aircraftModel.positionModel.longitude);

                    let lat = String(aircraftModel.positionModel.latitude);

                    let on_ground = String(aircraftModel.isOnGround());

                    let icao = aircraftModel.model.icao;

                    let baro_alt = String(aircraftModel.altitude * 0.3048);

                    let velocity = String(aircraftModel.trueAirspeed * 0.5144);

                    let squawk = String(aircraftModel.transponderCode);

                    let label;
                    
                    switch (aircraftModel.attackType) {
                        case GAME_ATTACK_TYPES.NON_RESPONSIVE:
                            label = "Not responding";
                            break;
                        case GAME_ATTACK_TYPES.POSITION_ALTERING:
                            label = "Changing position";
                            break;
                        case GAME_ATTACK_TYPES.FALSE_INFORMATION:
                            label = "False altitude and velocity";
                            break;
                        case GAME_ATTACK_TYPES.NON_MOVING:
                            label = "Standing still";
                            break;
                        case GAME_ATTACK_TYPES.FALSE_SQUAWK:
                            label = "False Squawk";
                            break;
                        case GAME_ATTACK_TYPES.FALSE_HEADING:
                            label = "False heading";
                            break;
                        case GAME_ATTACK_TYPES.DUPLICATED_AIRCRAFT:
                            label = "Duplicate";
                            break;
                        case GAME_ATTACK_TYPES.IMPERSONATED_AIRCRAFT:
                            label = "Impersonator";
                            break;
                        case GAME_ATTACK_TYPES.SYBIL:
                            label = "Main sybil node";
                            break;
                        case GAME_ATTACK_TYPES.FLOODING_OF_NON_RESPONSIVE:
                            label = "Flooding of non-responsive";
                            break;
                        default:
                            label = String(aircraftModel.attackType); // 1/2/3 etc. for attacks
                            break;
                    }

                    let true_track = String(aircraftModel.heading);

                    let attackType = String(aircraftModel.attackType);

                    let vertical_rate = String(aircraftModel.altRate);

                    let geo_alt = String(aircraftModel.geoAlt * 0.3048);

                    finalText += icao + ', ' + callsign + ', ' + time_position + ', ' + last_contact + ', ' + long + ', ' +
                        lat + ', ' + baro_alt + ', ' + on_ground + ', ' + velocity + ', ' + true_track + ', ' + vertical_rate + ', ' + geo_alt + ', ' +
                        squawk + ', ' + label + ', ' + attackType;
                    finalText += '\n';
                }
            }
            if ((seconds * 1000) < (performance.now() - start)) {
                clearInterval(this._downloadAttackDataInterval);
                this._downloadAttackDataInProgess = false;
                finalText.slice(0, -1); // Remove last comma
                var element = document.createElement('a');
                element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(finalText));
                element.setAttribute('download', "attackdata.csv");

                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
        }, sleep);
    }

    /**
     * Stops the download of the attack data.
     * 
     * @for AttacksDownloadController
     * @method _downloadAttackStop
     * @private
     */
    _downloadAttackStop() {
        clearInterval(this._downloadAttackDataInterval);
        clearInterval(this._downloadAttackDataCountdown);
        this._downloadAttackDataInProgess = false;
        console.log(this);
    }

    /**
     * Format the time for the countdown.
     * 
     * @for AttacksDownloadController
     * @method _formatTime
     * @param seconds {number}
     * @private
     * @return {string}
     */
    _formatTime(seconds) {
        let hours = Math.floor(seconds / 3600);
        let minutes = Math.floor((seconds % 3600) / 60);
        seconds = seconds % 60;
    
        // Pad the hours, minutes, and seconds with leading zeros if necessary
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
    
        return `${hours}:${minutes}:${seconds}`;
    }

    /**
     * Display the countdown for the attack data download.
     * 
     * @for AttacksDownloadController
     * @method _downloadAttackDisplayCountdown
     * @param seconds {number}
     * @private
     */
    _downloadAttackDisplayCountdown(seconds){
        let downloadAttackCountdownTimer = this._downloadAttackDataCollectionPeriod * 60;

        this._downloadAttackDataCountdown = setInterval(() => {
            downloadAttackCountdownTimer--;

            const $countdownSpan = this.$dialog.find(SELECTORS.DOM_SELECTORS.DOWNLOAD_ATTACK_LOG_COUNTDOWN);

            // Display the countdown
            $countdownSpan.html(this._formatTime(downloadAttackCountdownTimer));

            if (downloadAttackCountdownTimer <= 0) {
                clearInterval(this._downloadAttackDataCountdown);
            }
        }, 1000);
    }

    /**
     * Build the download buttons for the attacks download dialog.
     * 
     * @for AttacksDownloadController
     * @method _buildDownloadButtons
     * @private
     */
    _buildDownloadButtons() {
        const $container = $(UI_ATTACKS_DOWNLOAD_BUTTON_CONTAINER);

        $container.append(UI_ATTACKS_DOWNLOAD_ATTACK_DATA);
        $container.append(UI_ATTACKS_DOWNLOAD_ATTACK_STOP);
        // $container.append(UI_ATTACKS_DOWNLOAD_ATTACK_LOG); // Disabled for now as it as we have the test log

        // const $downloadLogButton = $container.find(SELECTORS.DOM_SELECTORS.DOWNLOAD_LOGFILE); // Disabled for now as it as we have the test log
        const $downloadAttackDataButton = $container.find(SELECTORS.DOM_SELECTORS.DOWNLOAD_ATTACK_LOG);
        const $downloadAttackStopButton = $container.find(SELECTORS.DOM_SELECTORS.DOWNLOAD_ATTACK_LOG_STOP);

        // $downloadLogButton.on('click', this._downloadSimulationLog); // Disabled for now as it as we have the test log
        $downloadAttackDataButton.on('click', this._downloadAttack);
        $downloadAttackStopButton.on('click', this._downloadAttackStop);

        return $container;
    }

    /**
     * Builds a div for selecting seconds for download of attackdata
     * 
     * @for AttacksDownloadController
     * @method _buildOptionForMinutes
     * @private
     */
    _buildOptionForMinutes() {
        const $container = $(UI_OPTION_CONTAINER_TEMPLATE);
        const $label = $(`<label for="${SELECTORS.IDS.DOWNLOAD_ATTACK_LOG_COUNTDOWN_SELECTION}">Minutes</label>`);
        const $input = $(`<input type="number" id="${SELECTORS.IDS.DOWNLOAD_ATTACK_LOG_COUNTDOWN_SELECTION}" value="30" min="0" >`);


        $input.on('change', (event) => {
            if (event.target.value > 0) {
                this._downloadAttackDataCollectionPeriod = event.target.value;
            }
        }); 

        $container.append($label);
        $container.append($input);

        return $container;
    }
}
